import React from 'react';
import styled from 'styled-components';

import { mediaMin } from '../../../Media Template/Media Template';

const Drawer = styled.div.attrs({})`
  width: 36px;
  height: 28px;
  display: flex;
  flex-flow: column;
  justify-content: space-around;
  align-items: center;
  box-sizing: border-box;
  cursor: pointer;
  div {
    width: 80%;
    height: 4px;
    border-radius: 8px;
    background-color: black;
  }
  ${mediaMin.desktop`display:none`};
`;

const drawerToggle = props => {
  return (
    <Drawer className="Drawer" onClick={props.clicked}>
      <div />
      <div />
      <div />
    </Drawer>
  );
};

export default drawerToggle;
